module.exports = __webpack_public_path__ + "app/principal/modals/modal-delete-company-1uCpK6bS.html";